'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function BuyTicketController($stateParams, $document, Ticket, EpayButton, $rootScope, TicketComponent) {
	'ngInject';

	var vm = this;
	var ePayButton = angular.element(document.getElementById('ePayButton'));
	var publicPage = angular.element(document.getElementById('publicParrent'));
	vm.ticketContent = $stateParams;
	vm.ticket = Ticket.data.data;

	init();

	/** */
	function init() {
		ePayButton.html(EpayButton[0].html);
		// Scroll top when enter state
		$document.scrollTo(publicPage, 0, 0);

		// 02/09/2022 - Temporarily disable online sales
		document.querySelector('.epay-btn').setAttribute('style', 'pointer-events: none; opacity: 0.5;');
		document.querySelector('.epay-btn').setAttribute('tabindex', '-1');
	}

	$rootScope.$on('$translateChangeSuccess', function () {
		TicketComponent.showTicket($stateParams.ticketId).then(function (res) {
			vm.ticket = res.data.data;
		});
	});
}

exports['default'] = BuyTicketController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/buy-ticket/buy-ticket.controller.js
 **/